export const documentTypes = [
  { value: "Company Formation", label: "Company Formation" },
  { value: "Operating Agreement", label: "Operating Agreement" },
  { value: "Others", label: "Others" },
];
